export const replaceOther = (arr: string[], item?: string): string[] => {
  return arr.map((el) => {
    if (el === "other" && item) {
      return item;
    }

    return el;
  });
};
